export default __webpack_public_path__ + "static/media/back_rand6.f287ad26.jpg";